import { ConnectionTestResult } from '@mss/mss-component-library';

export const emptyConnectionTest: ConnectionTestResult = {
  result: {
    message: null,
    status: {
      port: null,
      account: null,
      query: null,
    },
  },
  loading: false,
};
